import React, { useEffect, useState } from 'react'
import { getStoredAccounts, checkOAuthStatus } from '@/features/gmb/api'

export default function GMBDebug() {
  const [debugData, setDebugData] = useState<any>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadDebugData = async () => {
      try {
        console.log('Starting GMB debug...')

        // Check OAuth status
        const oauthStatus = await checkOAuthStatus()
        console.log('OAuth Status:', oauthStatus)

        // Get stored accounts
        const storedAccounts = await getStoredAccounts()
        console.log('Stored Accounts Response:', storedAccounts)

        setDebugData({
          oauthStatus,
          storedAccounts,
          accountsCount: storedAccounts.data?.accounts?.length || 0,
          locationsCount: storedAccounts.data?.locations?.length || 0,
          firstLocation: storedAccounts.data?.locations?.[0] || null
        })
      } catch (err) {
        console.error('Debug error:', err)
        setError(err instanceof Error ? err.message : 'Unknown error')
      } finally {
        setLoading(false)
      }
    }

    loadDebugData()
  }, [])

  if (loading) return <div>Loading debug data...</div>
  if (error) return <div>Error: {error}</div>

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-2xl font-bold">GMB Debug Information</h1>

      <div className="bg-muted p-4 rounded">
        <h2 className="font-semibold mb-2">OAuth Status</h2>
        <pre className="text-xs overflow-auto">
          {JSON.stringify(debugData?.oauthStatus, null, 2)}
        </pre>
      </div>

      <div className="bg-muted p-4 rounded">
        <h2 className="font-semibold mb-2">Summary</h2>
        <p>Accounts: {debugData?.accountsCount}</p>
        <p>Locations: {debugData?.locationsCount}</p>
      </div>

      <div className="bg-muted p-4 rounded">
        <h2 className="font-semibold mb-2">First Location</h2>
        <pre className="text-xs overflow-auto">
          {JSON.stringify(debugData?.firstLocation, null, 2)}
        </pre>
      </div>

      <div className="bg-muted p-4 rounded">
        <h2 className="font-semibold mb-2">Full Response</h2>
        <pre className="text-xs overflow-auto max-h-96">
          {JSON.stringify(debugData?.storedAccounts, null, 2)}
        </pre>
      </div>
    </div>
  )
}
